import React, { useState } from 'react';
import styled from 'styled-components';
import {
  ScanOutlined,
  SearchOutlined,
  StockOutlined,
  PlusCircleOutlined
} from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import { withRouter, Link } from 'react-router-dom';
import '@ant-design/compatible/assets/index.css';
import {
  Row,
  Col,
  Spin,
  Button,
  List,
  Tabs,
  Popover,
  Input,
  Table,
  Divider,
  Modal,
  Select,
  Card,
  InputNumber,
  Switch,
  AutoComplete,
  Badge,
  DatePicker
} from 'antd';
import moment from 'moment';
import Notify from 'src/components/meta/Notification';
import noImage from 'src/static/icons/carImageUpload/no-image-available.svg';
import Countdown from 'react-countdown-now';
import Highlighter from 'react-highlight-words';
import pdfMake from 'pdfmake/build/pdfmake';
import vfsFonts from 'pdfmake/build/vfs_fonts';
import { ButtonRadius } from 'src/components/elements/Button';
import prepDefinition from 'src/components/meta/PdfDefinition2';
import prepDefinition2 from 'src/components/meta/PdfDefinition3';
import { SSL_OP_SSLEAY_080_CLIENT_DH_BUG } from 'constants';
import SignatureCanvas from 'react-signature-canvas';
import {
  updateRig1,
  updateRig2,
  updateRig3,
  updateRig4,
  updateRig5,
  updateRig6,
  updateRig7,
  updateRig8,
  updateRig9,
  updateRig10
} from 'src/redux/actions/status';
import { connect } from 'react-redux';
import { thisExpression } from '@babel/types';
function onChange(date, dateString) {
  console.log(date, dateString);
}
const dateFormat = 'YYYY-MM-DD';
const { Option } = Select;
const { Column, ColumnGroup } = Table;
const { TextArea } = Input;
const FormItem = Form.Item;
const numeral = require('numeral');
const { TabPane } = Tabs;
const hammer = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6475 17.3418H1.65195C0.740018 17.3418 0 18.0817 0 18.9938V21.9977H14.2994V18.9938C14.2994 18.0817 13.5595 17.3418 12.6475 17.3418Z"
      fill="#AD5E00"
    />
    <path
      d="M21.7036 17.5744L11.6665 7.53725L13.6051 5.60203C13.9248 5.88391 14.4163 5.87013 14.7188 5.56766C15.0351 5.248 15.0351 4.7358 14.7188 4.41614L10.539 0.239743C10.2228 -0.0799143 9.70715 -0.0799143 9.39094 0.239743C9.07128 0.555998 9.07128 1.0716 9.39094 1.38781L9.35657 1.35344L4.04924 6.65728L4.08361 6.69505C3.76736 6.37539 3.25175 6.37539 2.93554 6.69505C2.61589 7.01131 2.61589 7.52691 2.93554 7.84317L7.11194 12.023C7.4316 12.3392 7.9472 12.3392 8.26346 12.023C8.57971 11.7033 8.57971 11.1912 8.26346 10.8715L8.29783 10.9058L10.2365 8.9706L20.2702 19.0043C20.6655 19.3996 21.3083 19.3996 21.7036 19.0043C22.0989 18.609 22.0989 17.9697 21.7036 17.5744Z"
      fill="#AD5E00"
    />
  </svg>
);

const StyledTable = styled(Table)`
  // .ant-table-thead > tr > th {
  //   text-align: center !important;

  // }
`;
const StyledDatePicker = styled(DatePicker)`
  width: 100%;
  height: 55px !important;
  border-radius: 0.5em !important;
  padding-top: 0px !important;
  .ant-picker-input > input {
    position: relative;
    display: inline-block;
    width: 100%;
    min-width: 0;
    padding: 4px 11px;
    color: rgba(0, 0, 0, 0.45) !important;
    font-size: 14px;
    line-height: 1.5715;
    background-color: #ffffff;
    background-image: none;
    border: 1px solid #e9e9e9;
    border-radius: 2px;
    transition: all 0.3s;
    flex: auto;
    min-width: 1px;
    height: auto;
    padding: 0;
    background: transparent;
    border: 0;
  }
`;
const StyledSelect = styled(Select)`
  .ant-select-selector {
    width: 100%;
    height: 55px !important;
    border-radius: 0.5em !important;
    padding-top: 11px !important;
  }
  .ant-select:not(.ant-select-customize-input)
    .ant-select-selector
    .ant-select-selection-search-input
    input {
    cursor: auto;
    padding-top: 1.2em !important;
  }
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    position: relative;
    color: red !important;
    background-color: #ffffff;
    border: 1px solid #e9e9e9;
    border-radius: 2px;
    padding-top: 1.2em !important;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  }
  .ant-select-selection-placeholder {
    color: rgba(0, 0, 0, 0.45) !important;
  }
`;
const StyledInput = styled(Input)`
  width: 100%;
  border-radius: 0.5em !important;
  ::placeholder {
    color: rgba(0, 0, 0, 0.45) !important;
  }
`;
const StyledBadge = styled(Badge)`
  .ant-badge-status-dot {
    height: 0.8em !important;
    width: 0.8em !important;
  }
`;
const StyledModal = styled(Modal)`
  .ant-modal-footer {
    display: none;
  }
`;

class Stock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      removedMeters: undefined,
      newBitStatus: undefined,
      replaceSize: undefined,
      replaceStatus: undefined,
      replaceLastUser: undefined,
      selectedBit: undefined,
      replaceSerial: undefined
    };
  }

  updateSignal;
  componentWillMount = () => {
    this.setState({ loading: true });
    this.props
      .findAllBits(this.props.user.access)
      .then(() => {
        this.setState({ loading: false });
      })
      .catch(e => {
        this.setState({ loading: false });
        Notify('error', e);
      });
    this.updateSignal = {
      signal: msg => {
        this.props
          .findAllBits(this.props.user.access)
          .then(() => {
            this.setState({ loading: false });
          })
          .catch(e => {
            this.setState({ loading: false });
            Notify('error', e);
          });
      }
    };
    window.pubnub.addListener(this.updateSignal);
    window.addEventListener('resize', this.resizeEvent);
    //if (window.cordova) {
    //  document.addEventListener("backbutton", this.handleBack);
    //}
  };

  componentWillUnmount = () => {
    window.pubnub.removeListener(this.updateSignal);
    window.removeEventListener('resize', this.resizeEvent);
    //if (window.cordova) {
    //  document.removeEventListener("backbutton", this.handleBack);
    //}
  };
  onRigUpdate = e => {
    this.props.updateRig1();
  };

  handleUpdateBits = () => {
    const { selectedBit } = this.state;

    this.props
      .updateBits({
        // TODO rigId: jy moet die selected rig se id of naam of watever hom link aan die rig hier sit,
        // TODO removedId: jy moet die selected bit se id hier sit,
        removedMeters: this.state.removedMeters || selectedBit.meter,
        removedStatus: selectedBit.status,
        replaceId: selectedBit._id,
        replaceSize: this.state.replaceSize || selectedBit.size,
        replaceStatus: this.state.newBitStatus || selectedBit.status,
        replaceLastUser: this.props.user.name,
        replaceSerial: selectedBit.serial,
        replaceCurrentRig: this.props.local.rig1
          ? '38'
          : this.props.local.rig2
          ? '91'
          : this.props.local.rig3
          ? '96'
          : this.props.local.rig4
          ? '99'
          : this.props.local.rig5
          ? '100'
          : this.props.local.rig6
          ? '102'
          : this.props.local.rig7
          ? '103'
          : this.props.local.rig8
          ? '107'
          : this.props.local.rig9
          ? '108'
          : this.props.local.rig10
          ? '113'
          : ''
      })

      .then(suc => {
        this.setState({ loading: false });
        // TODO wys success message en nav uit view uit
        this.props.push('/user/pexunits');
        //console.log(suc);
      })
      .catch(e => {
        this.setState({ loading: false });
        // TODO wys error message
        //console.log(e);
      });
  };

  render() {
    let { selectedBit } = this.state;

    const bitStatus = {
      damaged: <StyledBadge color="#EE4C4C" text="Damaged" />,
      Used: <StyledBadge color="#EDAC4B" text="Used" />,
      new: <StyledBadge color="#4BED5B" text="New" />,
      lost: <StyledBadge color="#D4D4D4" text="Lost" />,
      used: <StyledBadge color="#EE4C4C" text="Used" />,
      out: <StyledBadge color="#FF8F28" text="Out" />
    };

    return (
      <Spin spinning={this.state.loading}>
        <div>
          {' '}
          <Row
            type="flex"
            justify="start"
            align="middle"
            style={{ borderBottom: '1px solid #DDDDDD', height: '3.3em' }}
          >
            <Col
              xs={12}
              md={12}
              style={{ marginLeft: '-0.8em', marginTop: '-1.6em' }}
            >
              <span
                style={{
                  fontWeight: 500,
                  fontSize: 26,
                  color: '#FF9D66',
                  marginLeft: 10,
                  fontFamily: 'Roboto'
                }}
              >
                Rig{' '}
                {this.props.local.rig1
                  ? '1'
                  : this.props.local.rig2
                  ? '2'
                  : this.props.local.rig3
                  ? '3'
                  : this.props.local.rig4
                  ? '4'
                  : this.props.local.rig5
                  ? '5'
                  : this.props.local.rig6
                  ? '6'
                  : this.props.local.rig7
                  ? '7'
                  : this.props.local.rig8
                  ? '8'
                  : this.props.local.rig9
                  ? '9'
                  : this.props.local.rig10
                  ? '10'
                  : ''}
              </span>{' '}
              <br />
            </Col>
            <Col
              xs={12}
              md={12}
              style={{
                marginTop: '0.8em',
                textAlign: 'right'
              }}
            >
              <Col
                span={6}
                style={{ width: '5.5em', marginRight: '7.5em', float: 'right' }}
              >
                <StyledBadge
                  style={{ float: 'right' }}
                  color={
                    this.props.local.rig1
                      ? 'rgb(236, 129, 68 , 0.6)'
                      : this.props.local.rig2
                      ? '#EE4C4C'
                      : '#EE4C4C'
                  }
                />
              </Col>{' '}
              <Col
                span={18}
                style={{ float: 'right', width: '7.5em', whiteSpace: 'nowrap' }}
              >
                <p
                  style={{
                    fontWeight: 500,
                    fontSize: 26,
                    color: 'black',
                    marginLeft: 0,
                    fontFamily: 'Roboto',
                    marginTop: '-1.18em'
                  }}
                >
                  {this.props.local.rig1
                    ? '1020-01'
                    : this.props.local.rig2
                    ? '1020-02'
                    : this.props.local.rig3
                    ? '1020-03'
                    : this.props.local.rig4
                    ? '1020-04'
                    : this.props.local.rig5
                    ? '1020-05'
                    : this.props.local.rig6
                    ? 'None'
                    : this.props.local.rig7
                    ? '1020-07'
                    : this.props.local.rig8
                    ? '1020-08'
                    : this.props.local.rig9
                    ? '1020-09'
                    : this.props.local.rig10
                    ? '1020-10'
                    : ''}
                </p>
              </Col>
              <br />
            </Col>
          </Row>
          <Col
            xs={24}
            md={12}
            style={{
              marginLeft: '-0.8em',
              marginTop: '1.5em',
              marginBottom: '0.5em'
            }}
          >
            <span
              style={{
                fontWeight: 500,
                fontSize: 15,
                color: 'black',
                marginLeft: 10,
                fontFamily: 'Poppins'
              }}
            >
              Removed tool
            </span>
          </Col>
          <Row
            style={{
              background: 'white',
              borderRadius: 5,
              marginTop: 20,
              display: this.state.addBitsVisible ? 'flex' : 'none'
            }}
            type="flex"
            justify="space-around"
            align="middle"
          />
          <Row style={{ marginTop: '1em' }}>
            <Col span={11}>
              <StyledInput
                disabled
                placeholder={
                  this.props.local.rig1
                    ? '1020-01'
                    : this.props.local.rig2
                    ? '1020-02'
                    : this.props.local.rig3
                    ? 'None'
                    : this.props.local.rig4
                    ? '1020-04'
                    : this.props.local.rig5
                    ? '1020-05'
                    : this.props.local.rig6
                    ? 'None'
                    : this.props.local.rig7
                    ? '1020-07'
                    : this.props.local.rig8
                    ? '1020-08'
                    : this.props.local.rig9
                    ? '1020-09'
                    : this.props.local.rig10
                    ? 'None'
                    : ''
                }
                style={{ width: '100%', height: 55 }}
              />
            </Col>
            <Col span={2} />
            <Col span={11}>
              <StyledSelect
                disabled
                placeholder="Status"
                defaultValue="Hammer"
                style={{ width: '100%', height: 55 }}
                onChange={newBitStatus => this.setState({ newBitStatus })}
              >
                <Option value="Bit">Bit</Option>
                <Option value="Rod">Rod</Option>
                <Option value="Hammer">Hammer</Option>
                <Option value="Adapter">Adapter</Option>
                <Option value="Refurbish">Refurbish</Option>
              </StyledSelect>
            </Col>
          </Row>{' '}
          <Row style={{ marginTop: '1em' }}>
            <Col span={24}>
              <StyledInput
                disabled
                defaultValue="Hammer QL60 with Foot valve"
                placeholder="Description"
                style={{ width: '100%', height: 55, marginTop: '0em' }}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: '1em' }}>
            <Col span={11}>
              <StyledSelect
                placeholder="Status"
                style={{ width: '100%', height: 55 }}
                onChange={newBitStatus => this.setState({ newBitStatus })}
              >
                <Option value="Damaged">
                  <StyledBadge color="#EE4C4C" text="Damaged" />
                </Option>
                <Option value="Used">
                  <StyledBadge color="#EDAC4B" text="Used" />
                </Option>
                <Option value="New">
                  <StyledBadge color="#4BED5B" text="New" />
                </Option>
                <Option value="Lost">
                  <StyledBadge color="#D4D4D4" text="Lost" />
                </Option>
              </StyledSelect>
            </Col>
            <Col span={2} />
            <Col span={11}>
              <StyledInput
                placeholder="Meters"
                style={{ width: '100%', height: 55 }}
                onChange={e => this.setState({ removedMeters: e.target.value })}
              />
            </Col>
          </Row>
          <Col
            xs={24}
            md={12}
            style={{
              marginLeft: '-0.8em',
              marginTop: '1.5em',
              marginBottom: '0.5em'
            }}
          >
            <span
              style={{
                fontWeight: 500,
                fontSize: 15,
                color: 'black',
                marginLeft: 10,
                fontFamily: 'Poppins'
              }}
            >
              Replacement tool
            </span>
            <Link to="/user/dashboard">
              <span
                style={{
                  float: 'right',
                  fontWeight: 500,
                  fontSize: 15,
                  color: 'rgb(255, 157, 102)',
                  marginLeft: 10,
                  fontFamily: 'Poppins'
                }}
              >
                <PlusCircleOutlined /> Add Tool
              </span>
            </Link>
          </Col>
          <Row style={{ marginTop: '1em' }}>
            <Col span={11}>
              <StyledSelect
                placeholder="Serial"
                style={{ width: '100%' }}
                onChange={
                  // TODO weet nie wat hierdie is nie
                  // value => {
                  // value === '1020-03'
                  //   ? this.setState({
                  //       sizeValue: true,
                  //       sizeValue1: false
                  //     })
                  //   : value === '1020-04'
                  //   ? this.setState({
                  //       sizeValue1: true,
                  //       sizeValue: false
                  //     })
                  //   : this.setState({ sizeValue: false, sizeValue1: false });}
                  bitId => {
                    const selectedBit = this.props.bits.find(
                      bit => bit._id === bitId
                    );
                    this.setState({ selectedBit });
                  }
                }
              >
                {this.props.bits.map(bitserial => {
                  return (
                    <Option value={bitserial._id}>{bitserial.serial}</Option>
                  );
                })}
              </StyledSelect>
            </Col>
            <Col span={2} />
            <Col span={11}>
              <StyledSelect
                disabled
                hidden={!selectedBit ? true : false}
                placeholder={
                  selectedBit ? selectedBit.size : 'Description'
                  // this.state.sizeValue
                  //   ? '140mm'
                  //   : this.state.sizeValue1
                  //   ? '171mm'
                  //   : 'Size'
                }
                style={{ width: '100%', height: 55 }}
                onChange={e => this.setState({ replaceSize: e })}
              >
                {this.props.bits.map(bitsize => {
                  return <Option value={bitsize.size}>{bitsize.size}</Option>;
                })}
              </StyledSelect>
            </Col>
          </Row>
          <Row style={{ marginTop: '1em' }}>
            {' '}
            <Col span={24}>
              <StyledSelect
                hidden={!selectedBit ? true : false}
                placeholder={
                  selectedBit && selectedBit.status
                    ? bitStatus[selectedBit.status.toLowerCase()]
                    : 'No Status'
                }
                style={{ width: '100%', height: 55 }}
                disabled
                onChange={e => this.setState({ replaceStatus: e })}
              >
                <Option value="Damaged">
                  <StyledBadge color="#EE4C4C" text="Damaged" />
                </Option>
                <Option value="Used">
                  <StyledBadge color="#EDAC4B" text="Used" />
                </Option>
                <Option value="New">
                  <StyledBadge color="#4BED5B" text="New" />
                </Option>
                <Option value="Lost">
                  <StyledBadge color="#D4D4D4" text="Lost" />
                </Option>
              </StyledSelect>
            </Col>
          </Row>{' '}
          <Row style={{ marginTop: '1em' }}>
            <Col span={24}>
              <StyledInput
                disabled
                defaultValue="5 DHD Hammer"
                placeholder="Description"
                style={{ width: '100%', height: 55, marginTop: '0em' }}
              />
            </Col>
          </Row>{' '}
          <Row style={{ marginTop: '2.5em' }}>
            <ButtonRadius
              disabled={!selectedBit}
              style={{
                marginTop: '0em',
                height: 55,
                width: '100%',
                fontSize: 14,
                border: 'none',
                fontFamily: 'Open Sans',
                textShadow: 'none',
                backgroundColor: selectedBit ? '#EC8144' : '#cccccc',
                color: '#fff'
              }}
              type="primary"
              onClick={this.handleUpdateBits}
              size="large"
              block
            >
              Update
            </ButtonRadius>
          </Row>{' '}
        </div>{' '}
      </Spin>
    );
  }
}

const mapStateToProps = state => ({
  local: state.status
});

const mapDispatchToProps = {
  updateRig1,
  updateRig2,
  updateRig3,
  updateRig4,
  updateRig5,
  updateRig6,
  updateRig7,
  updateRig8,
  updateRig9,
  updateRig10
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Stock);
